const isUpperCase = (char: string): boolean => char.toUpperCase() === char;

const isLowerCase = (char: string): boolean => char.toLowerCase() === char;

const formatName = (displayName: string): string => {
  const KNOWN_PROXIES = ['De', 'La', 'Le', 'Mc'];
  return displayName
    .split(' ')
    .map((s) => {
      if (
        KNOWN_PROXIES.indexOf(s.slice(0, 2).toLowerCase()) &&
        isLowerCase(s.charAt(1)) &&
        isUpperCase(s.charAt(2))
      ) {
        return (
          s.charAt(0).toUpperCase() +
          s.charAt(1).toLowerCase() +
          s.charAt(2).toUpperCase() +
          s.slice(3)
        );
      }
      return s.charAt(0).toUpperCase() + s.slice(1);
    })
    .map((s) => s.trim().toLowerCase())
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
};

export default formatName;
